export default "__VITE_ASSET__BXnITQNR__"